var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6919 9.81694C11.4479 10.061 11.0521 10.061 10.8081 9.81694L7.1875 6.19638L3.56694 9.81694C3.32286 10.061 2.92714 10.061 2.68306 9.81694C2.43898 9.57286 2.43898 9.17714 2.68306 8.93306L6.74556 4.87056C6.86277 4.75335 7.02174 4.6875 7.1875 4.6875C7.35326 4.6875 7.51223 4.75335 7.62944 4.87056L11.6919 8.93306C11.936 9.17714 11.936 9.57286 11.6919 9.81694Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.1bb7a0a23a1d62ca696a1a0e1d2ed6e3.svg";
export { ForwardRef as ReactComponent };